/*! dependencies: infobubble, google-map-cluster */

var mapApiLoaded = false,
  mapApiLoading = false,
  mapScrollHandler = throttleDebounce.throttle(350, function () {
    if (!mapApiLoaded && !mapApiLoading && cash('.google-map').isInViewport(500)) {
      loadMapsApi();
    };
  });


cash(window).on('load', function () {
  //if (!mapApiLoaded && !mapApiLoading && cash('.google-map').isInViewport(0)) {
  if (!mapApiLoaded && !mapApiLoading) {
    loadMapsApi();
  }
});

function loadMapsApi() {
  if (!mapApiLoaded && !mapApiLoading) {

    cash(window).off('scroll', mapScrollHandler);

    var tag = document.createElement('script'),
      firstScriptTag = document.getElementsByTagName('script')[0];

    console.warn('REMINDER for Tea Solutions developers - Create an API key for google maps in the google developers console: https://console.developers.google.com. Add all the domains, test domains and local domains')
    tag.src = 'https://maps.googleapis.com/maps/api/js?key=' + instant.settings.googleApiKeyFrontend + '&callback=initMap&libraries=places,geometry';
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    mapApiLoading = true;
  }
}

var mapElement = null,
  map = null,
  markers = [],
  bounds = null,
  geocoder = null,
  searchBoxInput = null,
  searchBox = null,
  searchMarker = null;

window.initMap = function () {
  mapApiLoaded = true;
  mapApiLoading = false;
  mapElements = cash('.google-map'), allMaps = [];
  geocoder = new google.maps.Geocoder();

  searchBoxInput = cash('#search-location-input')[0];
  searchBox = new google.maps.places.SearchBox(searchBoxInput);

  searchBox.addListener("places_changed", () => {
    var searchAddress = searchBox.getPlaces()[0];
    var closestAddress = findClosestMapPin(searchAddress, markers);

    createSearchMarker(searchAddress);

    setBoundsAndCenterMap(searchAddress.geometry.location, closestAddress.position);
  });

  if (mapElements[0]) {
    var infoBubble = new InfoBubble({
      minWidth: 200,
      maxWidth: 300,
      minHeight: 150,
      padding: 15,
      shadowStyle: 3,
      backgroundColor: undefined,
      borderRadius: 7,
      arrowSize: 10,
      borderWidth: 1,
      borderColor: undefined,
      disableAutoPan: false,
      hideCloseButton: false,
      closeSrc: '/images/icons/close-cross.webp',
      arrowPosition: 50,
    });

    mapElements.each(function () {
      var mapElement = this,
        locations = cash(mapElement).find('[data-lat][data-lng]'),
        multipleLocations = (locations.length > 1),
        cluster = getBoolDataValue(mapElement, 'data-cluster'),
        interactive = getBoolDataValue(mapElement, 'data-interactive');

      if (multipleLocations) {
        bounds = new google.maps.LatLngBounds();
      }

      var mapOptions = {
        zoom: getZoomAttr(mapElement),
        draggable: interactive,
        zoomControl: interactive,
        scrollwheel: interactive ? undefined : interactive,
        streetViewControl: false,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        styles: getMapStyles()
      };

      if (!multipleLocations) {
        mapOptions.center = getLatLng(cash(locations[0]));
      }

      map = new google.maps.Map(mapElement, mapOptions);
      allMaps.push(map);

      locations.each(function () {
        var location = cash(this),
          name = location.attr('data-name'),
          latLng = new google.maps.LatLng(getLatLng(location)),
          marker = new google.maps.Marker({
            position: latLng,
            map: map,
            title: name,
            url: location.attr('data-url')
          });

        markers.push(marker);

        if (getBoolDataValue(mapElement, 'data-hideInfobox') == false) {
          marker.addListener('click', function () {
            if (!infoBubble.isOpen() || infoBubble.get('anchor') == marker) {
              infoBubble.setContent(location.html());
              infoBubble.open(map, marker);
            } else {
              infoBubble.close();
            }
          });
        } else if (marker.url) {
          google.maps.event.addListener(marker, 'click', function () {
            window.location.href = this.url;
          });
        }

        if (multipleLocations) {
          bounds.extend(latLng);
        }
      });

      if (cluster) {
        new MarkerClusterer(map, markers, {
          styles: [
            { textColor: 'white', height: 45, width: 45, url: cash(mapElement).data('cluster-icon'), backgroundPosition: 'center center' }
          ]
        });
      }

      if (multipleLocations) {
        map.fitBounds(bounds);
        //Set zoom level after fitBounds if zoom is lower than fitBounds' zoom level.
        var listener = google.maps.event.addListener(map, "idle", function () {
          var currentZoom = map.getZoom();
          var zoom = getZoomAttr(mapElement)
          if (zoom != 0 && currentZoom > zoom) {
            map.setZoom(zoom);
          }
          google.maps.event.removeListener(listener);
        });

        cash(window).on('resize', function () {
          var listener = google.maps.event.addListener(map, "idle", function () {
            map.fitBounds(bounds);
            google.maps.event.removeListener(listener);
          });
        });
      } else {
        google.maps.event.addListener(map, 'center_changed', function () {
          //a value to determine whether the map has been resized
          var size = [this.getDiv().offsetWidth, this.getDiv().offsetHeight].join('x');

          //when the center has changed, but not the size of the map
          if (!this.get('size') || size === this.get('size')) {
            this.setValues({ size: size, _center: this.getCenter() });
          }
          //when the map has been resized
          else {
            google.maps.event.addListenerOnce(this, 'idle', function () {
              this.setValues({ size: size, center: this.get('_center') });
            });
          }
        });
        //trigger the resize-event to initialize the size and _center-values
        google.maps.event.trigger(map, 'center_changed', {});
      }
    });
  }
};

cash('body').on('click', '#search-location-btn', function () {
  var address = cash('#search-location-input').val();
  if (!!address && address !== '') {
    geocoder.geocode({
      'address': address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        var searchAddress = results[0];
        var closestAddress = findClosestMapPin(searchAddress, markers);

        createSearchMarker(searchAddress);

        setBoundsAndCenterMap(searchAddress.geometry.location, closestAddress.position);
      } else {
        instant.toast.show('Geocode was not successful for the following reason: ' + status);
      }
    });
  }
});

cash('body').on('click', '#use-location-btn', function () {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var searchAddress = { geometry: { location: { lat: position.coords.latitude, lng: position.coords.longitude } } };
      var closestAddress = findClosestMapPin(searchAddress, markers);

      createSearchMarker(searchAddress);

      setBoundsAndCenterMap(searchAddress.geometry.location, closestAddress.position);
    });
  } else {
    x.innerHTML = 'Geolocation is not supported by this browser.';
  }
});

function getLatLng(location) {
  //console.log(location.attr('data-lng'));
  return { lat: getValueAsFloat(location.attr('data-lat')), lng: getValueAsFloat(location.attr('data-lng')) }
}

function getZoomAttr(mapElement) {
  return parseInt(cash(mapElement).attr('data-zoom'));
}

function getBoolDataValue(mapElement, attrName) {
  return JSON.parse(cash(mapElement).attr(attrName).toLowerCase());
}

function getMapStyles() {
  //Check other default styles here & create your own: https://mapstyle.withgoogle.com/
  return [];
}

function findClosestMapPin(address, markers) {
  console.log('markers:', markers);

  return markers.reduce(function (previous, current) {
    var currentPos = google.maps.geometry.spherical.computeDistanceBetween(address.geometry.location, current.position);
    var previousPos = google.maps.geometry.spherical.computeDistanceBetween(address.geometry.location, previous.position);

    return currentPos < previousPos ? current : previous;
  });
}

function createSearchMarker(searchAddress) {
  if (searchMarker != null) {
    searchMarker.setMap(null);
    searchMarker = null;
  }
  searchMarker = new google.maps.Marker({
    position: searchAddress.geometry.location,
    map: map,
    title: searchAddress.formatted_address,
    //icon: cash(mapElements[0]).data('search-icon'),
  });
}

function setBoundsAndCenterMap() {
  if (arguments.length > 0) {
    if (bounds != null) {
      bounds = null;
    }
    bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < arguments.length; i++) {
      bounds.extend(arguments[i]);
    }

    map.fitBounds(bounds);
    map.setCenter(bounds.getCenter());
  }
}

cash(function () {
  cash(window).on('scroll', mapScrollHandler);
});